import React, { useState } from 'react';
import { MessageCircle } from 'lucide-react';
import ContactForm from './ContactForm';

const ContactButton = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setIsFormOpen(true)}
        className="fixed bottom-6 right-6 z-40 flex items-center gap-2 px-6 py-3 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-full transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-105"
        aria-label="Contact Us - Report a problem or ask a question"
      >
        <MessageCircle className="w-5 h-5" />
        <span>Contact Us</span>
      </button>
      
      <ContactForm 
        isOpen={isFormOpen} 
        onClose={() => setIsFormOpen(false)} 
      />
    </>
  );
};

export default ContactButton;